<template>
    <div class="row">
        <div class="col-sm-12">
            <h2 class="h5 h-aside is-toggable-mobile">Filters</h2>

            <div class="flex">
                <div class="form-group">
                    <div class="row"><div class="col-sm-12"><label>From</label></div></div>
                    <el-date-picker
                        v-model="filters.from"
                        format="M/d/yyyy"
                        size="small"
                        value-format="yyyy-MM-dd"
                        type="date">
                    </el-date-picker>
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>To</label></div></div>
                    <el-date-picker
                        v-model="filters.to"
                        format="M/d/yyyy"
                        size="small"
                        value-format="yyyy-MM-dd"
                        type="date">
                    </el-date-picker>
                </div>
                <div v-if="campaignsOptions !== null" class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Campaign</label></div></div>
                    <el-select
                        v-model="filters.campaign"
                        filterable
                        clearable
                        multiple
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="cmp in campaignsOrdered"
                            :key="`filter_campaign_${cmp[0]}`"
                            :label="`${cmp[1]}`"
                            :value="cmp[0]">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="jobsOptions !== null" class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Job</label></div></div>
                    <el-select
                        v-model="filters.job"
                        filterable
                        clearable
                        multiple
                        size="small"
                        :filter-method="filterJobOptions"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="j in jobsFiltered"
                            :key="`filter_job_${j[0]}`"
                            :label="`${j[0]}`"
                            :value="j[0]">
                            {{ j[1] }}
                        </el-option>
                    </el-select>
                </div>
                <div v-if="employersOptions !== null" class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Employer</label></div></div>
                    <el-select
                        v-model="filters.employer"
                        filterable
                        clearable
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="e in employersOrdered"
                            :key="`filter_employer_${e[0]}`"
                            :label="`${e[1]}`"
                            :value="e[0]">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Lead Type</label></div></div>
                    <el-select
                        v-model="filters.appType"
                        filterable
                        clearable
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="a in appTypesOrdered"
                            :key="`filter_app_type_${a[0]}`"
                            :label="`${a[1]}`"
                            :value="a[0]">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Job Adviser</label></div></div>
                    <el-select
                        v-model="filters.agent"
                        filterable
                        clearable
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="a in agentsOrdered"
                            :key="`filter_agent_${a[0]}`"
                            :label="`${a[1]}`"
                            :value="a[0]">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Source</label></div></div>
                    <el-select
                        v-model="filters.source"
                        filterable
                        clearable
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="s in sourceOrdered"
                            :key="`filter_source_${s[0]}`"
                            :label="`${s[1]}`"
                            :value="s[0]">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="isGlobalPage" class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Job Title</label></div></div>
                    <input type="text" class="form-control" size="small" placeholder="or Job Nickname" v-model="filters.title" v-on:keyup.enter="change">
                </div>
            </div>
            <div class="flex">
                <div class="form-group">
                    <div class="row"><div class="col-sm-12"><label>Name</label></div></div>
                    <input type="text" class="form-control" size="small" v-model="filters.name" v-on:keyup.enter="change">
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Email</label></div></div>
                    <input type="text" class="form-control" size="small" v-model="filters.email" placeholder="Exact match only" v-on:keyup.enter="change">
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Phone</label></div></div>
                    <input type="text" class="form-control" size="small" v-model="filters.phone" placeholder="Exact match only" v-on:keyup.enter="change">
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Zip</label></div></div>
                    <input type="text" class="form-control" size="small" v-model="filters.zip" placeholder="Comma separated list" v-on:keyup.enter="change">
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Source</label></div></div>
                    <el-select
                        v-model="filters.state"
                        filterable
                        clearable
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="(name, id) in stateOptions"
                            :key="`filter_state_${id}`"
                            :label="name"
                            :value="id">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Min CDL XP</label></div></div>
                    <el-select
                        v-model="filters.minCdlXp"
                        filterable
                        clearable
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="e in cdlXpOrdered"
                            :key="`filter_min_xp_${e[0]}`"
                            :label="e[1]"
                            :value="e[0]">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Max CDL XP</label></div></div>
                    <el-select
                        v-model="filters.maxCdlXp"
                        filterable
                        clearable
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="e in cdlXpOrdered"
                            :key="`filter_max_xp_${e[0]}`"
                            :label="e[1]"
                            :value="e[0]">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Min CDL A XP</label></div></div>
                    <el-select
                        v-model="filters.minCdlA"
                        filterable
                        clearable
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="e in cdlAOrdered"
                            :key="`filter_min_a_${e[0]}`"
                            :label="e[1]"
                            :value="e[0]">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group" style="margin-left:10px">
                    <div class="row"><div class="col-sm-12"><label>Max CDL A XP</label></div></div>
                    <el-select
                        v-model="filters.maxCdlA"
                        filterable
                        clearable
                        size="small"
                        :trigger-on-focus="false">
                        <el-option
                            v-for="e in cdlAOrdered"
                            :key="`filter_max_a_${e[0]}`"
                            :label="e[1]"
                            :value="e[0]">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group" style="padding:25px 0 0 10px">
                    <btn cssClass="btn-info" :click="change" icon="fas fa-filter">Filter</btn>
                </div>
                <div class="form-group" style="padding:25px 0 0 10px" v-if="!isGlobalPage">
                    <btn cssClass="btn-info" :click="() => showExportDialog = true" icon="fad fa-download">Export CSV</btn>
                </div>
            </div>
        </div>

        <ApplicationsExportDialog :show="showExportDialog"
                                  :filters="filters"
                                  @close="showExportDialog = false"/>
    </div>
</template>

<script>
import ApplicationsExportDialog from './applications-export-dialog';

export default {
        props: {
            value: { type: Object, required: true },
            isGlobalPage: { type: Boolean, required: true },
            employersOptions: { type: Object, required: false, default: null },
            campaignsOptions: { type: Object, required: false, default: null },
            jobsOptions: { type: Object, required: false, default: null },
            appTypesOptions: { type: Object, required: true },
            cdlXpOptions: { type: Object, required: true },
            cdlAOptions: { type: Object, required: true },
            stateOptions: { type: Object, required: true },
            sourceOptions: { type: Object, required: true },
            agentsOptions: { type: Object, required: true },
        },
        components: { ApplicationsExportDialog },
        data() {
            return {
                filters: this.value,
                showExportDialog: false,
                jobsFiltered: []
            };
        },
        computed: {
            campaignsOrdered() {
                return this.orderOptions(this.campaignsOptions, 1, false);
            },
            employersOrdered() {
                return this.orderOptions(this.employersOptions, 1, false);
            },
            jobsOrdered() {
                return this.orderOptions(this.jobsOptions, 0, true);
            },
            appTypesOrdered() {
                return this.orderOptions(this.appTypesOptions, 1, false);
            },
            cdlXpOrdered() {
                return this.orderCdlOptions(this.cdlXpOptions);
            },
            cdlAOrdered() {
                return this.orderCdlOptions(this.cdlAOptions);
            },
            sourceOrdered() {
                return this.orderOptions(this.sourceOptions, 1, false);
            },
            agentsOrdered() {
                return this.orderOptions(this.agentsOptions, 1, false);
            },
        },
        watch: {
            value: {
                deep: true,
                handler() {
                    this.filters = _.cloneDeep(this.value);
                },
            }
        },
        mounted() {
            this.filterJobOptions('');
        },
        methods: {
            change() {
                this.$emit('input', this.filters);
            },
            filterJobOptions(input) {
                input = _.lowerCase(input);
                this.jobsFiltered = _.filter(this.jobsOrdered, (x) => _.lowerCase(x[1]).includes(input));
            },
            orderCdlOptions(options) {
                let temp = _.toPairs(options);
                temp = _.map(temp, (item) => {
                    // -500 as string is ordered differently than integer
                    // for correct order, we need integers instead of strings
                    if (item[0] !== '') {
                        item[0] = parseInt(item[0]);
                    } else {
                        // we want ALL option to be on the first place, so lets add it the smallest number
                        item[0] = -1000;
                    }
                    return item;
                });
                temp = _.orderBy(temp, [0], ['asc']);
                temp[0][0] = '';// return default value to ALL option, we changed it above
                return temp;
            },
            orderOptions(options, itemToBeOrderedBy, isInteger) {
                let temp = _.toPairs(options);

                return _.sortBy(temp, [
                    function (row) {
                        if (row[1] === 'All') return isInteger ? -1000 : '-1000';
                        if (row[1] === 'None') return isInteger ? -999 : '-999';

                        let val = row[itemToBeOrderedBy];
                        if (isInteger) val = parseInt(val);
                        else val = val.toLowerCase();
                        return val;
                    }]);
            },
        },
    };
</script>
